<template>
    <div id="tu-anlegen-root">
        <div id="title-row" class="m-3">
            <h4>Untersuchung hinzufügen</h4>
        </div>
        <template>
            <div id="untersuchungsdatum-und-modalitaet">
                <b-form-group
                        id="input-tu-modality"
                        :invalid-feedback="infoTextNoOptionSelected"
                        :state="tuModalitySelected"
                        label="Untersuchungsmodalität:"
                        label-for="tu-modalitaet"
                        label-cols-sm="2" label-cols-lg="4"
                >
                    <b-form-select style="width: 300px;"
                                   v-model="selectedModality"
                                   :options="modalityOptions"
                                   @change="onModalityOptionsChanged"
                                   :state="tuModalitySelected"
                                   id="tu-modalitaet"
                    />
                </b-form-group>
                <b-form-group label="Untersuchungsdatum:"
                              label-for="tu-datum"
                              label-cols-sm="2" label-cols-lg="4">
                    <b-form-input type="date" style="width: 300px;" v-model="tuDate" required :state="tuDateEntered"
                                  aria-describedby="input-live-feedback" :min="patient.birthDate" :max="todayDate" @change="resetDateState"
                                  id="tu-datum"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback">
                        {{ infoTextNotValidDate }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
        </template>
        <div id="untersuchungsdetails" v-if="selectedModality">
            <b-form-group
                    id="answers"
                    :invalid-feedback="infoTextNoOptionSelected"
                    :state="tuOptionModalitySelected"
                    :label="erklaerText"
                    label-for="tu-result"
                    label-cols-sm="2" label-cols-lg="4"
            >
                <b-form-radio-group
                        stacked
                        v-model="selectedOptionForModality"
                        :options="optionsForSelectedModality"
                        @change="resetOptionsForModalityState"
                        id="tu-result"/>
            </b-form-group>
        </div>
        <div id="button-tu-verwerfen">
            <b-button variant="outline-danger" v-on:click="showDeletionModal">Verwerfen
                <b-icon-trash></b-icon-trash>
            </b-button>
        </div>
        <div id="button-tu-weiter">
            <b-button variant="outline-success" v-on:click="finished"> {{ editingTU ? 'Speichern' : 'Hinzufügen' }}
                <b-icon-check-circle/>
            </b-button>
        </div>

        <DeletionModal centered
                       :show="deletionModalDisplayed"
                       :header-message="'Technische Untersuchungerfassung wirklich abbrechen?'"
                       :subheader-message="'Bisher gemachte Eintragungen werden nicht gespeichert.'"
                       :abort-button-label="'Erfassung fortsetzen'"
                       :confirm-button-label="'Abbrechen und Daten verwerfen'"
                       :modal-size="'lg'"
                       @close="closeDeletionModal"
                       @deleteConfirm="deleteTU"/>
    </div>
</template>

<script>
import tuModule from "../../../js/clinical-algorithm/technischeUntersuchungen/technischeUntersuchungenAlgorithm";
import tuConfiguration from '../../../js/clinical-algorithm/technischeUntersuchungen/Stage2_Befunde.csv'
import {mapGetters, mapState} from "vuex";
import infoTexte from "../../../js/clinical-algorithm/infoTexte/infoTexte"
import {isoDateFormat} from "../../../js/util";
import DeletionModal from "../../modal/DeletionModal";

export default {
    name: "TUAnlegenComponent",
    components: {DeletionModal},
    emits: {
        canceled: null,
        finished: null,
    },
    props: {
        indexOfEditedTU: Number
    },
    data() {
        return {
            tuDate: undefined,
            selectedModality: undefined,
            selectedOptionForModality: undefined,
            deletionModalDisplayed: false,
            editingTU: false,
            infoTextNotValidDate: "",
            tuDateEntered: null,
            tuModalitySelected: null,
            tuOptionModalitySelected: null,
            infoTextNoOptionSelected: infoTexte.noOptionSelected,

        }
    },
    computed: {
        ...mapState('cdss/technischeUntersuchungen', ['untersuchungen']),
        modalityOptions() {
            // This removes duplicates and makes the order alphabetical
            return [...new Set(tuModule.readTUConfiguration(tuConfiguration).map(conf => conf['MODALITY']))].sort()
        },
        optionsForSelectedModality() {
            if (this.selectedModality) {
                return tuModule.readTUConfiguration(tuConfiguration)
                    .filter(conf => conf['MODALITY'] === this.selectedModality)
                    .map(conf => {
                        return {
                            value: conf,
                            text: conf['FINDING_TEXT']
                        }
                    })
            } else {
                return undefined
            }
        },
        erklaerText() {
            return infoTexte['technischeUntersuchungenErklaertextNeueAnlegen'] + " " + this.selectedModality
        },
        todayDate() {
            return isoDateFormat(new Date())
        },
        ...mapGetters('cdss', [
            'patient'
        ])
    },
    methods: {
        closeDeletionModal() {
            this.deletionModalDisplayed = false;
        },
        deleteTU() {
            this.$emit('canceled')
            this.closeDeletionModal()
        },
        showDeletionModal() {
            this.deletionModalDisplayed = true;
        },
        validDate(date) {
            const pattern = /^\d{4}-\d{2}-\d{2}$/;
            if (!pattern.test(date)) {
                this.tuDateEntered = false
                this.infoTextNotValidDate = infoTexte.notValidDate
                return false
            } else if (new Date(date) > new Date()) {
                this.tuDateEntered = false
                this.infoTextNotValidDate = infoTexte.dateInTheFuture
                return false
            } else if (new Date(date) < new Date(this.patient.birthDate)) {
                this.tuDateEntered = false
                this.infoTextNotValidDate = infoTexte.dateBeforeBirth
                return false
            } else {
                this.tuDateEntered = null
                return true
            }
        },
        finished() {
            if (this.validDate(this.tuDate) && this.selectedOptionForModality) {
                this.$emit('finished', {date: new Date(this.tuDate), value: this.selectedOptionForModality})
            } else if (!this.selectedModality) {
                this.tuModalitySelected = false
            } else if (!this.selectedOptionForModality) {
                this.tuOptionModalitySelected = false
            }
        },
        resetModalityState(answer) {
            if (!this.tuModalitySelected && answer !== undefined) {
                this.tuModalitySelected = null
            }
        },
        resetDateState(date) {
            if (!this.tuDateEntered && date !== "") {
                this.tuDateEntered = null
            }
        },
        onModalityOptionsChanged(option) {
            this.selectedOptionForModality = undefined;
            this.resetModalityState(option);
        },
        resetOptionsForModalityState(option) {
            if (!this.tuOptionModalitySelected && option !== undefined) {
                this.tuOptionModalitySelected = null
            }
        }
    },
    mounted() {
        // If we edit an existing entry, re-fill with the previous answers
        if (this.indexOfEditedTU !== undefined) {
            this.selectedModality = this.untersuchungen[this.indexOfEditedTU].value['MODALITY']
            this.selectedOptionForModality = this.untersuchungen[this.indexOfEditedTU].value
            this.tuDate = isoDateFormat(new Date(this.untersuchungen[this.indexOfEditedTU].date))
            this.editingTU = true
        }
    }
}
</script>

<style scoped>
#tu-anlegen-root {
    display: grid;
    grid-template-areas:
      "title title title"
      ". untersuchungsdatum-und-modalitaet ."
      ". untersuchungsdetails ."
      "button-tu-verwerfen button-tu-weiter .";
    grid-gap: 20px;
    grid-template-columns: 1fr 3fr 2fr;
    grid-template-rows: 40px auto 1fr 50px;
    height: 100%;
}

#title-row {
    grid-area: title;
}

#untersuchungsdatum-und-modalitaet {

    grid-area: untersuchungsdatum-und-modalitaet;
    padding-top: 50px;
}

#untersuchungsdetails {
    grid-area: untersuchungsdetails;
    display: grid;

}

#button-tu-verwerfen {
    justify-self: start;
    align-self: center;
    grid-area: button-tu-verwerfen;
    padding-bottom: 5px;
    padding-left: 5px;
}

#button-tu-weiter {
    justify-self: end;
    align-self: center;
    grid-area: button-tu-weiter;
    padding-bottom: 5px;
}
</style>